import { Button } from '@progress/kendo-react-buttons';
import { WarningIcon } from 'app/components/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './InitializationErrorPage.less';

export default function InitializationErrorPage() {
  const { t } = useTranslation();

  return (
    <div className="initialization-error-page">
      <div className="initialization-error-page__header">
        <img src="/logo.svg" alt="logo" />
      </div>

      <div className="initialization-error-page__content">
        <WarningIcon height={90} width={90} />

        <h1 className="initialization-error-page__title">
          {t('initialization_error.title')}
        </h1>

        <h2 className="initialization-error-page__subtitle">
          {t('initialization_error.subtitle')}
        </h2>

        <Button
          className="initialization-error-page__reload-button"
          themeColor="primary"
          onClick={() => window.location.reload()}
          style={{ width: '100%' }}
        >
          {t('initialization_error.reload_button')}
        </Button>
      </div>
    </div>
  );
}
